<div fxFlex="100" fxLayout="column" fxLayoutAlign="center center">
    <app-banner></app-banner>
    <h3>{{'nfTitle' | translate}}</h3>
    <button type="button" style="margin-top: -20px;" (click)="openInfoDialog()" mat-icon-button>
        <mat-icon>info</mat-icon>
</button>
    <div class="form-container" *ngIf="!serial || !imei">
        <h4 fxLayout="row wrap"  fxLayoutAlign="space-around center">{{'identify' | translate}}</h4>
        <form fxLayout="row wrap" #heroForm="ngForm" fxLayoutAlign="space-around center">
        
        <mat-form-field fxFlex="60" fxFlex.lt-md="100" appearance="fill" *ngIf="!serial">
        <mat-label>{{'serialNumber' | translate}}</mat-label>
        <input required [(ngModel)]="serialNumber" matInput name="serialOrImeiNumber">
        </mat-form-field>
        <div fxFill fxLayout="row wrap" fxLayoutAlign="center center">
            
            <mat-form-field fxFlex="60" fxFlex.lt-md="100" appearance="fill" ngClass.gt-sm="info-input" *ngIf="!imei">
            <mat-label>{{'imeiNumber' | translate}}</mat-label>
            <input required [(ngModel)]="imeiNumber" matInput name="serialOrImeiNumber">
            </mat-form-field>
            
        </div>
            
            
            <button mat-raised-button color="primary" [disabled]="!serialNumber && !imeiNumber" (click)="onSubmitSearch()">{{'searchDevice' | translate}}</button>
        </form>
    </div>
    <div><p>{{'nfText1' | translate}} <br><br>

        {{'nfText2' | translate}}<br><br>
        {{'nfText3' | translate}}</p></div>
    <div fxLayoutAlign="space-around center" fxLayoutGap="20px">
        <button mat-raised-button color="primary"  [routerLink]="['/home']">{{'nfBack' | translate}}</button>
        <button mat-raised-button color="primary"  (click)="onSubmit()" >{{'nfButton' | translate}}</button>
    </div>
</div>
